import { DetailedTableInfoDc, GeometryType } from "@evergis/api";
import { TableInfo } from "../../../interfaces/resourceInfo";

export const getTableAlias = (table: TableInfo) => table && (table.alias || table.name);

export function getTableInfo(tableInfo?: DetailedTableInfoDc): TableInfo {
  return tableInfo
    ? {
        ...tableInfo,
        objectsCount: tableInfo.rowCount,
        geometryType: (tableInfo.geometries && tableInfo.geometries[0]) || ("unknown" as GeometryType),
      }
    : {
        objectsCount: 0,
      };
}
